// extracted by mini-css-extract-plugin
module.exports = {"intro":"Hero_intro__k4Iqz"};